<template>
  <i class="tm-tracks">
    <tm-tracks-visual>
      <tm-visual
        v-for="track in visual"
        :key="track.guid"
        :track="track"
        @hoveredRectangle="$_onHoveredVisualRectangle"
      />
    </tm-tracks-visual>

    <tm-visual-audio-gap />

    <tm-tracks-audio>
      <tm-audio
        v-for="track in audio"
        :key="track.guid"
        :track="track"
        @hoveredRectangle="$_onHoveredAudioRectangle"
      />

      <tm-audio-shadow />
    </tm-tracks-audio>

    <tm-visual-menu :hoveredRectangle="this.$data.hoveredVisualRectangle" />
    <tm-audio-menu :hoveredRectangle="this.$data.hoveredAudioRectangle" />
    <tm-visual-scene-menu />
    <tm-optional-audio-insert-menu />

    <tm-tracks-fog />
  </i>
</template>

<script>
import { mapState } from 'vuex';
import tmTracksVisual from './tmTracksVisual.vue';
import tmVisual from './visual/tmVisual.vue';
import tmTracksAudio from './tmTracksAudio.vue';
import tmAudio from './audio/tmAudio.vue';
import tmAudioShadow from './audio/tmAudioShadow.vue';
import tmVisualMenu from '../menu/tmVisualMenu.vue';
import tmAudioMenu from '../menu/tmAudioMenu.vue';
import tmVisualSceneMenu from '../menu/tmVisualSceneMenu.vue';
import tmOptionalAudioInsertMenu from '../menu/tmOptionalAudioInsertMenu.vue';
import tmTracksFog from './tmTracksFog.vue';
import tmVisualAudioGap from '../indicator/tmVisualAudioGap.vue';

export default {
  name: 'tm-tracks',
  components: {
    tmTracksVisual,
    tmVisual,
    tmVisualAudioGap,
    tmTracksAudio,
    tmAudio,
    tmAudioShadow,
    tmVisualMenu,
    tmAudioMenu,
    tmVisualSceneMenu,
    tmOptionalAudioInsertMenu,
    tmTracksFog,
  },

  data() {
    return {
      hoveredVisualRectangle: null,
      hoveredAudioRectangle: null,
    };
  },

  computed: {
    ...mapState('timemachine', {
      visual: (state) => state.trackLayer.visual,
      audio: (state) => state.trackLayer.audio,
      showVisualAnchors: (state) => state.dndEscort.showVisualAnchors,
    }),
  },

  methods: {
    $_onHoveredVisualRectangle(rectangle) {
      this.$data.hoveredVisualRectangle = rectangle;
    },

    $_onHoveredAudioRectangle(rectangle) {
      this.$data.hoveredAudioRectangle = rectangle;
    },
  },
};
</script>

<style lang="scss">
.tm-timemachine > .tm-tracks {
}
</style>
